module.exports = __webpack_public_path__ + "img/logo.9462fdb5.png";